// NOTE: This file must remain a JS file because
// it's used in `vite.config.js`

export const VERSION = '3.5.0'
export const RELEASE_TIME = 1748932301624
